/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  // {
  //   id: "applications",
  //   title: "Applications",
  //   type: "basic",
  //   icon: "heroicons_outline:square-3-stack-3d",
  //   link: "/applications",
  // },
  {
    id: "newapplications",
    title: "Applications",
    type: "basic",
    icon: "heroicons_outline:square-3-stack-3d",
    link: "/adaptive-ui-flow/list",
    authorities: "APPLICATIONS",
  },
  {
    id: "task-tray",
    title: "Tasks",
    type: "basic",
    icon: "heroicons_outline:rectangle-stack",
    link: "/task-tray",
    authorities: "TASKS",
  },
  {
    id: "loans",
    title: "Loans",
    type: "basic",
    icon: "heroicons_outline:credit-card",
    link: "/loans/list",
    authorities: "LOANS",
  },
  {
    id: "report",
    title: "Report",
    // subtitle: "Generate and download reports",
    type: "collapsable",
    icon: "heroicons_outline:chart-bar-square",
    authorities: "GENERATE_REPORT",
    children: [
      {
        id: "feePaymentReport",
        title: "Digital Payment Report",
        subtitle: "Download fee collection transactions",
        type: "basic",
        icon: "heroicons_outline:banknotes",
        link: "/report",
        authorities: "DIGITAL_PAYMENT_REPORT",
      },
      {
        id: "loanPipelineCsvReport",
        title: "Loan Pipeline Report",
        subtitle: "Download dynamic CSV report",
        type: "basic",
        icon: "heroicons_outline:table-cells",
        link: "/report/dynamic-csv",
        authorities: "DYNAMIC_CSV_REPORT",
      },
    ],
  },
  {
    id: "masters",
    title: "Masters",
    subtitle: "Manage master entites",
    type: "group",
    icon: "heroicons_outline:circle-stack",
    authorities: "MASTERS",
    children: [
      {
        id: "refrence-code",
        title: "Refrence Code",
        subtitle: "Add, edit and inactivate refrence codes",
        type: "basic",
        icon: "heroicons_outline:code",
        link: "/masters/reference-code",
        authorities: "REF_CODE",
      },
      {
        id: "user",
        title: "User",
        subtitle: "Add, edit and remove users",
        type: "basic",
        icon: "heroicons_outline:users",
        link: "/masters/user/list",
        authorities: "USER",
      },
      {
        id: "branch",
        title: "Branch",
        subtitle: "Add, edit and remove branches  and authorities",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/branch/list",
        authorities: "BRANCH",
      },
      {
        id: "branchset",
        title: "Branch Set",
        subtitle: "Add, edit and remove branch sets",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/branchset/branchset-list",
        authorities: "BRANCH_SET",
      },
      {
        id: "role",
        title: "Role",
        subtitle: "Add, edit and remove roles and authorities",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/role/list",
        authorities: "ROLE",
      },
      {
        id: "productCategory",
        title: "Product Category",
        subtitle: "Add, edit and remove products",
        type: "basic",
        icon: "heroicons_outline:adjustments-horizontal",
        link: "/masters/product-category/list",
        authorities: "PRODUCT_CATEGORY",
      },
      // {
      //   id: "product",
      //   title: "Product",
      //   subtitle: "Add, edit and remove products",
      //   type: "basic",
      //   icon: "heroicons_outline:adjustments-horizontal",
      //   link: "/masters/product/list",
      // },
      {
        id: "products",
        title: "Product",
        subtitle: "Add, edit and remove product",
        type: "basic",
        icon: "heroicons_outline:adjustments-horizontal",
        link: "/masters/products/list",
        authorities: "PRODUCT",
      },
      {
        id: "entityStageConfiguration",
        title: "Entity Stage Configuration",
        subtitle: "Add, edit and remove entity stage configurations",
        type: "basic",
        icon: "heroicons_outline:identification",
        link: "/masters/entityStageConfiguration/list",
        authorities: "ENTITY_STAGE_CONFIGURATION",
      },
      {
        id: "entitybuilder",
        title: "Entity Builder",
        subtitle: "JSON based form builder",
        type: "basic",
        icon: "heroicons_outline:square-3-stack-3d",
        link: "/masters/entity-builder/entity-list",
        authorities: "ENTITY_BUILDER",
      },
      {
        id: "deviationCategory",
        title: "Deviation Matrix",
        subtitle: "Manage deviation matrix",
        type: "basic",
        icon: "heroicons_outline:squares-2x2",
        link: "/masters/deviationCategory/list",
        authorities: "DEVIATION_MATRIX",
      },
      {
        id: "adaptiveUI",
        title: "Adaptive UI",
        subtitle: "Add, edit and remove adaptiveUI entites",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/adaptiveUI/list",
        authorities: "ADAPTIVE_UI",
      },
      {
        id: "workFlowManager",
        title: "Work Flow Manager",
        subtitle: "Add, edit and remove work flow manager entites",
        type: "basic",
        icon: "heroicons_outline:briefcase",
        link: "/masters/workFlowManager/list",
        authorities: "WORKFLOW_MANAGER",
      },
      {
        id: "entityValueRuleMaster",
        title: "Entity Value Rule Master",
        subtitle: "View rules configured",
        type: "basic",
        icon: "heroicons_outline:briefcase",
        link: "/masters/entity-value-rule-master/list",
        authorities: "RULES_MASTER",
      },
      {
        id: "rulesMaster",
        title: "Rules Master",
        subtitle: "View rules configured",
        type: "basic",
        icon: "heroicons_outline:briefcase",
        link: "/masters/rules-master",
        authorities: "RULES_MASTER",
      },
      {
        id: "declarationMaster",
        title: "Declaration Master",
        subtitle: "Add declaration",
        type: "basic",
        icon: "heroicons_outline:clipboard-document-check",
        link: "/masters/declaration-master/list",
        authorities: "DECLARATION_MASTER",
      },
      {
        id: "documentchecklist",
        title: "Document Check List",
        subtitle: "Add, edit and remove document checklist data",
        type: "basic",
        icon: "heroicons_outline:document-check",
        link: "/masters/document-checklist/list",
        authorities: "DOCUMENT_CHECKLIST",
      },
      {
        id: "checklistMaster",
        title: "Checklist",
        subtitle: "Add, edit and remove checklist templates",
        type: "basic",
        icon: "heroicons_outline:clipboard-document-check",
        link: "/masters/checklist/list",
        authorities: "CHECKLISTMASTER_FILTER_PAGINATED",
      },
      {
        id: "loanReportsMaster",
        title: "Loan Reports Master",
        subtitle: "Add, edit and remove loan report configurations",
        type: "basic",
        icon: "heroicons_outline:document-chart-bar",
        link: "/masters/loan-reports-master/list",
        authorities: "LOAN_REPORTS_MASTER_FILTER_PAGINATED",
      },
      {
        id: "exceptionMaster",
        title: "Exception Master",
        subtitle: "Add, edit and remove exceptionMaster data",
        type: "basic",
        icon: "heroicons_outline:document-check",
        link: "/masters/exception-master/list",
      },
    ],
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "applications",
    title: "Applications",
    type: "basic",
    icon: "heroicons_outline:square-3-stack-3d",
    link: "/applications",
    authorities: "APPLICATIONS",
  },
  {
    id: "task-tray",
    title: "Tasks",
    type: "basic",
    icon: "heroicons_outline:rectangle-stack",
    link: "/task-tray",
    authorities: "TASKS",
  },
  {
    id: "report",
    title: "Report",
    type: "collapsable",
    icon: "heroicons_outline:chart-bar-square",
    authorities: "GENERATE_REPORT",
    children: [
      {
        id: "feePaymentReport",
        title: "Digital Payment Report",
        subtitle: "Download fee collection transactions",
        type: "basic",
        icon: "heroicons_outline:banknotes",
        link: "/report",
        authorities: "DIGITAL_PAYMENT_REPORT",
      },
      {
        id: "loanPipelineCsvReport",
        title: "Loan Pipeline Report",
        subtitle: "Download dynamic CSV report",
        type: "basic",
        icon: "heroicons_outline:table-cells",
        link: "/report/dynamic-csv",
        authorities: "GENERATE_REPORT",
      },
    ],
  },
  // {
  //   id: "loans",
  //   title: "Loans",
  //   type: "basic",
  //   icon: "heroicons_outline:credit-card",
  //   link: "/loans",
  // },
  {
    id: "masters",
    title: "Masters",
    subtitle: "Manage master entites",
    type: "group",
    icon: "heroicons_outline:circle-stack",
    authorities: "MASTERS",
    children: [
      {
        id: "refrence-code",
        title: "Refrence Code",
        subtitle: "Add, edit and inactivate refrence codes",
        type: "basic",
        icon: "heroicons_outline:code",
        link: "/masters/reference-code",
        authorities: "REF_CODE",
      },
      {
        id: "user",
        title: "User",
        subtitle: "Add, edit and remove users",
        type: "basic",
        icon: "heroicons_outline:users",
        link: "/masters/user/list",
        authorities: "USER",
      },
      {
        id: "role",
        title: "Role",
        subtitle: "Add, edit and remove roles and auhtorities",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/role/list",
        authorities: "ROLE",
      },
      // {
      //   id: "product",
      //   title: "Product",
      //   subtitle: "Add, edit and remove products",
      //   type: "basic",
      //   icon: "heroicons_outline:adjustments",
      //   link: "/masters/product/list",
      // },
      {
        id: "products",
        title: "Products",
        subtitle: "Add, edit and remove products",
        type: "basic",
        icon: "heroicons_outline:adjustments-horizontal",
        link: "/masters/products/list",
        authorities: "PRODUCT",
      },
      {
        id: "entityStageConfiguration",
        title: "Entity Stage Configuration",
        subtitle: "Add, edit and remove entity stage configurations",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/entityStageConfiguration/list",
        authorities: "ENTITY_STAGE_CONFIGURATION",
      },
    ],
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "applications",
    title: "Applications",
    type: "basic",
    icon: "heroicons_outline:square-3-stack-3d",
    link: "/applications",
    authorities: "APPLICATIONS",
  },
  {
    id: "task-tray",
    title: "Tasks",
    type: "basic",
    icon: "heroicons_outline:rectangle-stack",
    link: "/task-tray",
    authorities: "TASKS",
  },
  {
    id: "report",
    title: "Report",
    type: "collapsable",
    icon: "heroicons_outline:chart-bar-square",
    authorities: "GENERATE_REPORT",
    children: [
      {
        id: "feePaymentReport",
        title: "Digital Payment Report",
        subtitle: "Download fee collection transactions",
        type: "basic",
        icon: "heroicons_outline:banknotes",
        link: "/report",
        authorities: "DIGITAL_PAYMENT_REPORT",
      },
      {
        id: "loanPipelineCsvReport",
        title: "Loan Pipeline Report",
        subtitle: "Download dynamic CSV report",
        type: "basic",
        icon: "heroicons_outline:table-cells",
        link: "/report/dynamic-csv",
        authorities: "GENERATE_REPORT",
      },
    ],
  },
  // {
  //   id: "loans",
  //   title: "Loans",
  //   type: "basic",
  //   icon: "heroicons_outline:credit-card",
  //   link: "/loans",
  // },
  {
    id: "masters",
    title: "Masters",
    subtitle: "Manage master entites",
    type: "group",
    icon: "heroicons_outline:circle-stack",
    authorities: "MASTERS",
    children: [
      {
        id: "refrence-code",
        title: "Refrence Code",
        subtitle: "Add, edit and inactivate refrence codes",
        type: "basic",
        icon: "heroicons_outline:code",
        link: "/masters/reference-code",
        authorities: "REF_CODE",
      },
      {
        id: "user",
        title: "User",
        subtitle: "Add, edit and remove users",
        type: "basic",
        icon: "heroicons_outline:users",
        link: "/masters/user/list",
        authorities: "USER",
      },
      {
        id: "role",
        title: "Role",
        subtitle: "Add, edit and remove roles and auhtorities",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/role/list",
        authorities: "ROLE",
      },
      // {
      //   id: "product",
      //   title: "Product",
      //   subtitle: "Add, edit and remove products",
      //   type: "basic",
      //   icon: "heroicons_outline:adjustments",
      //   link: "/masters/product/list",
      // },
      {
        id: "products",
        title: "Products",
        subtitle: "Add, edit and remove products",
        type: "basic",
        icon: "heroicons_outline:adjustments-horizontal",
        link: "/masters/products/list",
        authorities: "PRODUCT",
      },
      {
        id: "entityStageConfiguration",
        title: "Entity Stage Configuration",
        subtitle: "Add, edit and remove entity stage configurations",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/entityStageConfiguration/list",
        authorities: "ENTITY_STAGE_CONFIGURATION",
      },
    ],
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "applications",
    title: "Applications",
    type: "basic",
    icon: "heroicons_outline:square-3-stack-3d",
    link: "/applications",
    authorities: "APPLICATIONS",
  },
  {
    id: "task-tray",
    title: "Tasks",
    type: "basic",
    icon: "heroicons_outline:rectangle-stack",
    link: "/task-tray",
    authorities: "TASKS",
  },
  {
    id: "report",
    title: "Report",
    type: "collapsable",
    icon: "heroicons_outline:chart-bar-square",
    authorities: "GENERATE_REPORT",
    children: [
      {
        id: "feePaymentReport",
        title: "Digital Payment Report",
        subtitle: "Download fee collection transactions",
        type: "basic",
        icon: "heroicons_outline:banknotes",
        link: "/report",
        authorities: "DIGITAL_PAYMENT_REPORT",
      },
      {
        id: "loanPipelineCsvReport",
        title: "Loan Pipeline Report",
        subtitle: "Download dynamic CSV report",
        type: "basic",
        icon: "heroicons_outline:table-cells",
        link: "/report/dynamic-csv",
        authorities: "GENERATE_REPORT",
      },
    ],
  },
  // {
  //   id: "loans",
  //   title: "Loans",
  //   type: "basic",
  //   icon: "heroicons_outline:credit-card",
  //   link: "/loans",
  // },
  {
    id: "masters",
    title: "Masters",
    subtitle: "Manage master entites",
    type: "group",
    icon: "heroicons_outline:circle-stack",
    authorities: "MASTERS",
    children: [
      {
        id: "refrence-code",
        title: "Refrence Code",
        subtitle: "Add, edit and inactivate refrence codes",
        type: "basic",
        icon: "heroicons_outline:code",
        link: "/masters/reference-code",
        authorities: "REF_CODE",
      },
      {
        id: "user",
        title: "User",
        subtitle: "Add, edit and remove users",
        type: "basic",
        icon: "heroicons_outline:users",
        link: "/masters/user/list",
        authorities: "USER",
      },
      {
        id: "role",
        title: "Role",
        subtitle: "Add, edit and remove roles and auhtorities",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/role/list",
        authorities: "ROLE",
      },
      // {
      //   id: "product",
      //   title: "Product",
      //   subtitle: "Add, edit and remove products",
      //   type: "basic",
      //   icon: "heroicons_outline:adjustments",
      //   link: "/masters/product/list",
      // },
      {
        id: "products",
        title: "Product",
        subtitle: "Add, edit and remove products",
        type: "basic",
        icon: "heroicons_outline:adjustments-horizontal",
        link: "/masters/products/list",
        authorities: "PRODUCT",
      },
      {
        id: "entityStageConfiguration",
        title: "Entity Stage Configuration",
        subtitle: "Add, edit and remove entity stage configurations",
        type: "basic",
        icon: "heroicons_outline:adjustments",
        link: "/masters/entityStageConfiguration/list",
        authorities: "ENTITY_STAGE_CONFIGURATION",
      },
    ],
  },
];
